import type {RefCallback} from 'react';

/** MUI DialogContent ref is typed loosely; coerce to HTMLElement for idle auto-save. */
export function dialogContentElRef(
  setEl: (el: HTMLElement | null) => void,
): RefCallback<unknown> {
  return (node) => {
    setEl((node as HTMLElement | null) ?? null);
  };
}
